import store from "@/store"

export default function supermanager({ next, router }) {
    if(!store || !store.state.auth.isLogged || !['manager', 'account_manager'].includes(store.state.auth.user.role)) {
        router.push('/admin/login')
        return
    }
    return next()
}
